// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1526":"e464e486","5143":"82642839","6107":"dee480a3","9506":"445bfc28"}[chunkId] + ".chunk.css";
};